import {Paper, PaperProps, styled} from "@mui/material";

export const SidebarContainer = styled((props: PaperProps) => (
    <Paper elevation={1} square {...props}/>
))(({ theme }) => ({
    position: 'fixed',
    overflow: 'auto',
    zIndex: 100,
    top: '60px',
    width: '15rem',
    height: '100%',
    paddingBottom: '60px',
    hideScrollbar: 'true',

    color: theme.barekam.text.regular,
    backgroundColor: theme.barekam.sidebar.background,
}));

export const SidebarLogo = styled('div')(() => ({
    padding: '1.5rem',
    width: '100%',
    gap: '0.5rem',
    borderBottom: '1px solid #F1F1FB',
    borderRadius: '0px',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
}))